import React, { useState, useEffect } from 'react';

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Verificar al cargar
    checkMobile();

    // Agregar listener para cambios de tamaño
    window.addEventListener('resize', checkMobile);

    // Limpiar listener
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const backgroundImage = isMobile 
    ? 'url(/images/home/HOME-Smartphone.jpg)' 
    : 'url(/images/home/PMG-HOME.jpg)';

  return (
    <section style={{...styles.section, backgroundImage}}>
      <div style={styles.overlay}></div>
    </section>
  );
};

const styles = {
  section: {
    minHeight: '100vh',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontFamily: 'Roboto, sans-serif',
    position: 'relative',
  },
  // overlay: {
  //   position: 'absolute',
  //   inset: 0,
  //   background: 'rgba(0, 0, 0, 0.2)',
  // },
};

export default Home;
